import React from 'react';
import { PoliciesPermissionSetItems } from 'common/constants/permissions';
import { getInitialPermissionContext } from 'utils/permission.utils';

export type TPermissionContext = Record<keyof typeof PoliciesPermissionSetItems, boolean>;

const PermissionContext = React.createContext<TPermissionContext>(getInitialPermissionContext());

export default PermissionContext;
